import { CalculoContext } from 'context/Calculo'
import { useContext } from 'react'

export function useCalculo() {
    return useContext(CalculoContext)
}
